var map = {
	"./images/logo_bottom.png": "3f2f",
	"./images/skin-B/logo_bottom.png": "7bee",
	"./images/skin-G/logo_bottom.png": "45f5",
	"./images/skin-Gift/logo_bottom.png": "5e14",
	"./images/skin-O/logo_bottom.png": "46d5",
	"./images/skin-T/logo_bottom.png": "f8d8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f215";